import { Component, HostBinding, Input } from '@angular/core';

import { EventModel, FootballScore, ScoreboardType, SportType } from '@frontend/sports/betting-offer/feature/model';

@Component({
    template: '',
})
export abstract class GridScoreboardBaseComponent {
    @Input() event: EventModel;
    scoreboardType = ScoreboardType;

    @HostBinding('class.hidden')
    get display(): boolean {
        if (!this.event.scoreboard) {
            return true;
        }

        if (this.event.scoreboard.sportType === SportType.LeaderboardGame) {
            return false;
        }

        return !this.event.scoreboard.started;
    }

    get penaltyShootout(): boolean {
        return (
            (this.event.scoreboard.sportType === SportType.Football || this.event.scoreboard.sportType === SportType.PeriodGame) &&
            !!this.event.scoreboard.getScore<FootballScore>()!.penaltyShootOutScore
        );
    }

    get isSnooker(): boolean {
        return this.event.scoreboard.sportType === SportType.Snooker;
    }
}
